module.exports = __webpack_public_path__ + "static/media/property-manager.55f2eaf9.jpg";